var map = {
	"./clothing_01.png": "8UeT",
	"./clothing_02.png": "y+zV",
	"./clothing_03.png": "MLT7",
	"./clothing_04.png": "7CeK",
	"./clothing_05.png": "VH37",
	"./clothing_06.png": "nPY3",
	"./clothing_07.png": "fmEn",
	"./clothing_08.png": "LriO",
	"./clothing_09.png": "AByu",
	"./clothing_10.png": "yd+t",
	"./clothing_11.png": "IMGy",
	"./clothing_12.png": "z9SB",
	"./clothing_13.png": "Q01I"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F8Q2";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large ^\.\/.*\.png$
// module id = F8Q2
// module chunks = 0